import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import './Header.scss';

const Header: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [hoveredNav, setHoveredNav] = useState<string | null>(null);

  const navItems = [
    { id: 'features', label: 'Функционал' },
    { id: 'demo', label: 'Интерактив Демо' },
    { id: 'advantages', label: 'Единое окно контроля' },
    { id: 'testimonials', label: 'Отзывы клиентов' },
    { id: 'onboarding', label: 'Почему beheard' }
  ];

  const [isHidden, setIsHidden] = useState(false);

  useEffect(() => {
    let lastScrollY = window.scrollY;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      setIsScrolled(currentScrollY > 50);

      if (currentScrollY > lastScrollY && currentScrollY > 150) {
        // Scrolling down
        setIsHidden(true);
      } else if (currentScrollY < lastScrollY) {
        // Scrolling up
        setIsHidden(false);
      }
      
      lastScrollY = currentScrollY;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <motion.header 
      className={`header ${isScrolled ? 'header--scrolled' : ''}`}
      initial={{ y: -120 }}
      animate={{ y: isHidden ? -120 : 0 }}
      transition={{ duration: 0.4, ease: "easeInOut" }}
    >
      <div className="container">
        <div className="header__content">
          <motion.div 
            className="header__logo"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <img src="/logo.png" alt="beheard" className="logo-img" />
          </motion.div>

          <nav 
            className={`header__nav ${isMobileMenuOpen ? 'header__nav--open' : ''}`}
            onMouseLeave={() => setHoveredNav(null)}
          >
            {navItems.map(item => (
              <button 
                key={item.id}
                className="nav__link"
                onClick={() => scrollToSection(item.id)}
                onMouseEnter={() => setHoveredNav(item.id)}
              >
                {item.label}
                {hoveredNav === item.id && (
                  <motion.div
                    layoutId="nav-hover"
                    className="nav-hover-bg"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ type: "spring", stiffness: 450, damping: 30 }}
                  />
                )}
              </button>
            ))}
          </nav>

          <motion.button 
            className="btn btn--primary header__cta"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => scrollToSection('contact')}
          >
            Запросить демо
          </motion.button>

          <button 
            className={`header__mobile-toggle ${isMobileMenuOpen ? 'header__mobile-toggle--active' : ''}`}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle mobile menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </motion.header>
  );
};

export default Header;
